export default __webpack_public_path__ + "media/images/correct-a8941fa3daca492afb34482bcdea7192.png";